/**
 * @generated SignedSource<<bf7b4a8382bb6ba4d6fe971d26f562b4>>
 * @relayHash fba5658ca66a75586b4f89387ea00fa1
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fba5658ca66a75586b4f89387ea00fa1

import { ConcreteRequest } from 'relay-runtime';
export type usePhoneNumberCountryListQuery$variables = {
  language: string;
};
export type usePhoneNumberCountryListQuery$data = {
  readonly displayableCountries: ReadonlyArray<{
    readonly countryIsoCode2: string;
    readonly countryLookup: {
      readonly countryIsoCode2: string;
      readonly dialCode: string;
      readonly mask: string | null;
    };
    readonly countryName: string;
    readonly id: string;
    readonly language: string;
  }>;
};
export type usePhoneNumberCountryListQuery = {
  response: usePhoneNumberCountryListQuery$data;
  variables: usePhoneNumberCountryListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "language"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "language"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryIsoCode2",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mask",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dialCode",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePhoneNumberCountryListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CountryLookupTranslation",
        "kind": "LinkedField",
        "name": "displayableCountries",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CountryLookup",
            "kind": "LinkedField",
            "name": "countryLookup",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "usePhoneNumberCountryListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CountryLookupTranslation",
        "kind": "LinkedField",
        "name": "displayableCountries",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CountryLookup",
            "kind": "LinkedField",
            "name": "countryLookup",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "fba5658ca66a75586b4f89387ea00fa1",
    "metadata": {},
    "name": "usePhoneNumberCountryListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e5620255cc7ca903bcee10d908325e4c";

export default node;
